const ACADEMY_PREFIX = "/academy";

export const AssignmentApiEndpoints = {
  SEARCH_PEOPLE_AND_TEAMS: `${ACADEMY_PREFIX}/assignment/organization`,
  CREATE_ASSIGNMENT: `${ACADEMY_PREFIX}/assignment/organization`,
  GET_ALL_ASSIGNMENTS: `${ACADEMY_PREFIX}/assignment/organization`,
  GET_ASSIGNMENT_DETAILS: `${ACADEMY_PREFIX}/assignment`,
  UPDATE_ASSIGNMENT: `${ACADEMY_PREFIX}/assignment`,
  GET_ASSIGNMENT_TEAMS_AND_PLAYERS: `${ACADEMY_PREFIX}/assignment/organization`,
  GET_PLAYER_ASSIGNMENTS: `${ACADEMY_PREFIX}/assignment/organization`,
  GET_PLAYER_ASSIGNMENT_FORM: `${ACADEMY_PREFIX}/assignment/task-response`,
  SEND_ASSIGNMENT_NOTIFICATION_EMAIL: `${ACADEMY_PREFIX}/email/assignment`,
  GET_PLAYER_TASK_DETAILS: `${ACADEMY_PREFIX}/assignment`,
  CLOSE_OR_REMOVE_ASSIGNMENT: `${ACADEMY_PREFIX}/assignment/close-remove`,
  CREATE_FAVORITE_ASSIGNMENT: `${ACADEMY_PREFIX}/assignment/favorite`,
  DELETE_FAVORITE_ASSIGNMENT: `${ACADEMY_PREFIX}/assignment/favorite`,
  CHECK_ASSIGNMENT_IS_FAVORITE: `${ACADEMY_PREFIX}/assignment/favorite`
};
